export var EnumProductStates;

(function (EnumProductStates) {
  EnumProductStates["toBasket"] = "to_basket";
  EnumProductStates["inBasket"] = "in_basket";
  EnumProductStates["revert"] = "revert";
  EnumProductStates["notAvailable"] = "not_available";
})(EnumProductStates || (EnumProductStates = {}));

export var EnumButtonSize;

(function (EnumButtonSize) {
  EnumButtonSize["large"] = "large";
  EnumButtonSize["normal"] = "normal";
  EnumButtonSize["small"] = "small";
})(EnumButtonSize || (EnumButtonSize = {}));

export var EnumCardSize;

(function (EnumCardSize) {
  EnumCardSize["medium"] = "medium";
  EnumCardSize["small"] = "small";
})(EnumCardSize || (EnumCardSize = {}));

export var EnumCardType;

(function (EnumCardType) {
  EnumCardType["full"] = "full";
  EnumCardType["short"] = "short";
})(EnumCardType || (EnumCardType = {}));

export var EnumFavoriteStates;

(function (EnumFavoriteStates) {
  EnumFavoriteStates["default"] = "default";
  EnumFavoriteStates["unlogged"] = "unlogged";
})(EnumFavoriteStates || (EnumFavoriteStates = {}));

export var EnumProductType;

(function (EnumProductType) {
  EnumProductType["piece"] = "piece";
  EnumProductType["pack"] = "pack";
  EnumProductType["weight"] = "weight";
})(EnumProductType || (EnumProductType = {}));

var EnumProductSpecialType;

(function (EnumProductSpecialType) {
  EnumProductSpecialType["new"] = "new";
})(EnumProductSpecialType || (EnumProductSpecialType = {}));

export var EnumCurrency;

(function (EnumCurrency) {
  EnumCurrency["rur"] = "rur";
})(EnumCurrency || (EnumCurrency = {}));